/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Faq_Origin_QInputs */

const en_road_dude_faq_origin_q = /** @type {(inputs: Road_Dude_Faq_Origin_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is this the same as the State Property meme?`)
};

const zh_road_dude_faq_origin_q = /** @type {(inputs: Road_Dude_Faq_Origin_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它和 State Property 是同一个梗吗？`)
};

/**
* | output |
* | --- |
* | "Is this the same as the State Property meme?" |
*
* @param {Road_Dude_Faq_Origin_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_faq_origin_q = /** @type {((inputs?: Road_Dude_Faq_Origin_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Faq_Origin_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_faq_origin_q(inputs)
	return zh_road_dude_faq_origin_q(inputs)
});
export { road_dude_faq_origin_q as "road_dude.faq.origin.q" }